/**
 * ks-video-gallery – Lightbox für die Bilder-Galerie.
 *
 * Öffnet die Galerie-Bilder per GLightbox. Jede Sektion erhält eine
 * eigene Lightbox-Gruppe (eigene Vor-/Zurück-Navigation), damit mehrere
 * ks-video-gallery-Blöcke auf einer Seite nicht vermischt werden.
 */

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

export default function initGalleryLightbox(selector = '.ks-video-gallery') {
  const sections = document.querySelectorAll(selector);

  sections.forEach((section, index) => {
    const links = section.querySelectorAll('.ks-video-gallery__lightbox');
    if (!links.length) return;

    // Pro Sektion eine eigene Gruppe/Selector, damit die Lightbox-
    // Navigation nur innerhalb dieser Galerie läuft.
    const groupClass = `ks-video-gallery__lightbox--group-${index}`;
    links.forEach((link) => link.classList.add(groupClass));

    GLightbox({
      selector: `.${groupClass}`,
      touchNavigation: true,
      loop: true,
    });
  });
}
